<script>
    import { page } from '$app/stores';
    import Card from '$lib/Card.svelte';
    import Courses from '$lib/Courses.svelte';
    import Form from '$lib/Form.svelte';
    import H2 from '$lib/H2.svelte';
    import KoFiDonate from '$lib/KoFiDonate.svelte';
    import PageLayout from '$lib/PageLayout.svelte';
    import PageSection from '$lib/PageSection.svelte';
    import Prose from '$lib/Prose.svelte';
    import ScrollableSection from '$lib/ScrollableSection.svelte';
    import Worksheets from '$lib/Worksheets.svelte';

    // import text from `$lib/content/pages/${page.params.content_page}.md?raw`;
    export let data;

    // console.log('content page.s', data);


    $: show_donate = $page.params.content_page === 'support-us';

    let courses = show_donate
        ? []
        : data?.courses?.filter(
              (course) => course.price
          ) || [];

    let worksheets = show_donate
        ? []
        : data?.worksheets || [];
</script>

<PageLayout>
    <PageSection>
        <Prose class="mx-auto">
            {@html data.content}
        </Prose>

        <hr class="mx-auto max-w-2xl" />
        {#if show_donate}
            <Card class="mt-4 md:p-8 mx-auto max-w-2xl text-center">
                <KoFiDonate />
            </Card>
        {:else}
            <Card class="mt-4 md:p-8 mx-auto max-w-2xl">
                <Form
                    label_text="Don't miss new posts! Subscribe to my newsletter:"
                    cta_text="Subscribe"
                    success_message="Thank you for subscribing!"
                />
            </Card>
        {/if}
    </PageSection>

    {#if courses.length > 0}
        <PageSection class="my-12 lg:my-24">
            <H2 lg class="mb-4 lg:mb-8">Courses</H2>

            <ScrollableSection
                class="negate-page-section-px"
                content_class="flex gap-4 md:gap-6 flex-nowrap"
            >
                <Courses {courses} class="snap-center min-w-[280px]" />
            </ScrollableSection>
        </PageSection>
    {/if}

    {#if worksheets.length > 0}
        <PageSection class="my-12 lg:my-24">
            <H2 lg class="mb-4 lg:mb-8">Worksheets</H2>

            <ScrollableSection
                class="negate-page-section-px"
                content_class="flex gap-4 md:gap-6 flex-nowrap"
            >
                <Worksheets
                    {worksheets}
                    h_level={3}
                    class="snap-center min-w-[280px]"
                />
            </ScrollableSection>
        </PageSection>
    {/if}
</PageLayout>
